import Link from 'next/link'

export function Footer() {
	return (
		<footer aria-labelledby="footer-heading" className="relative">
			<h2 id="footer-heading" className="sr-only">
				Footer
			</h2>
			<div className="mx-auto max-w-7xl px-6 pb-8 pt-4 lg:px-8">
				<div className="border-t border-white/10 pt-8 md:flex md:items-center md:justify-center">
					<p className="text-xs leading-5 text-gray-400">
						&copy; {new Date().getFullYear()} <Link href="https://getstell.com">Stell Tech AS</Link>. All
						rights reserved.
					</p>
				</div>
			</div>
		</footer>
	)
}
